// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"63b19374","926":"5332e7c4"}[chunkId] + ".chunk.css";
};